export const API_TRACKING_GOAL = '/Analytics/TriggerProductInterestGoal';